<template>
  <div class="grid grid-flow-col grid-cols-3 gap-4 ml-4">
    <div class="download-button-table">
      <button
        class="
          download-button-table
          text-purple
          border-4 border-purple
          rounded-full
          w-full
          h-10
          hover:text-white hover:bg-purple
          disabled:opacity-50
        "
        @click.stop="downloadPdf('cashbooks', item.year)"
        :disabled="!item.cashbooksExist"
      >
        <div class="flex flex-row items-center justify-center">
          <download-icn
            width="20px"
            height="20px"
            class="mr-1 purple-icon hover-white-icon"
          ></download-icn>
          <span class="font-bold text-lg">出納帳</span>
          <money-icn
            width="20px"
            height="20px"
            class="ml-1 hover-white-icon"
            fill-rule="evenodd"
            fill="#A068E0"
          ></money-icn>
        </div>
      </button>
    </div>
    <div>
      <!-- 領収書月別ダウンロード -->
      <AppDownloadMonthBtn
        color="purple"
        :year="item.year"
      ></AppDownloadMonthBtn>
    </div>
    <div class="download-button-table">
      <button
        class="
          text-purple
          border-4
          border-purple 
          rounded-full 
          w-full 
          h-10 
          hover:text-white 
          hover:bg-purple 
          disabled:opacity-50
        "
        @click.stop="
          requireIdDownload(
            'approveHistory',
            item.year,
            getDenominationId(currentUser.role.is_office_worker),
          )
        "
        :disabled="!item.approveHistory"
      >
        <div class="flex flex-row items-center justify-center">
          <download-icn
            width="20px"
            height="20px"
            class="mr-1 purple-icon hover-white-icon"
          ></download-icn>
          <span class="font-bold text-lg">確認履歴</span>
          <comfirm-icn
            width="26px"
            height="20px"
            class="ml-1 hover-white-icon"
            fill-rule="evenodd"
            fill="#A068E0"
          ></comfirm-icn>
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import DownloadIcn from '@/assets/icons/download.svg?inline'
import MoneyIcn from '@/assets/icons/money-circle.svg?inline'
import ComfirmIcn from '@/assets/icons/comfirm-purple.svg?inline'
import AppDownloadMonthBtn from '@/components/ui/AppDownloadMonthBtn.vue'
import { useDenominationSelect } from '@/services/useDenominationSelect'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useDownloads } from '@/services/useDownloads'

export default {
  name: 'DownloadButton_YOKOHAMA',
  components: {
    DownloadIcn,
    MoneyIcn,
    ComfirmIcn,
    AppDownloadMonthBtn,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  setup() {
    const { selectedDenomination } = useDenominationSelect()
    const { currentUser } = useCurrentUser()

    const getDenominationId = roleNum => {
      if (roleNum === 1) {
        return selectedDenomination.value.denominationId !== undefined
          ? selectedDenomination.value.denominationId
          : null
      }
      return 0
    }

    return {
      selectedDenomination,
      currentUser,
      getDenominationId,
      ...useDownloads(),
    }
  },
}
</script>

<style lang="scss">
.download-button-table {
  width: 100%;
  :disabled {
    pointer-events: none;
  }
}
.download-button-table :hover svg.hover-white-icon {
  path {
    fill: #fff;
  }
}
button[disabled] {
  pointer-events: none;
}
</style>
